import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { User, Video, ArrowRight } from 'lucide-react';

interface ShareOwnerCardProps {
  videoTitle: string;
  onGoToShared: () => void;
}

export function ShareOwnerCard({ videoTitle, onGoToShared }: ShareOwnerCardProps) {
  useLanguage();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="w-full bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.08)] overflow-hidden"
    >
      <div className="p-8 sm:p-10 text-center">
        {/* Icon */}
        <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-5">
          <User className="w-8 h-8 text-primary" />
        </div>

        {/* Title */}
        <h1 className="text-xl sm:text-2xl font-bold text-foreground mb-2">
          {translateInterfaceText("Você é o proprietário deste vídeo")}</h1>
        <p className="text-sm text-muted-foreground max-w-sm mx-auto mb-4">
          {translateInterfaceText("Este link de compartilhamento pertence ao vídeo:")}</p>
        
        {/* Video info */}
        <div className="inline-flex items-center gap-2 bg-slate-50 rounded-lg px-4 py-2 text-sm">
          <Video className="w-4 h-4 text-muted-foreground" />
          <span className="font-medium text-foreground">{videoTitle}</span>
        </div>
      </div>

      {/* CTA */}
      <div className="px-8 sm:px-10 pb-8 sm:pb-10">
        <Button
          onClick={onGoToShared}
          className="w-full h-12 bg-[#4B7BFF] hover:bg-[#3B6BEF] text-white font-medium"
        >
          {translateInterfaceText("Gerenciar compartilhamentos")}<ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </motion.div>
  );
}
